<template>
  <div class="upper-limb-orthosis-step-three-a">
    <div class="content">
      <div class="img-container">
        <img src="@/assets/img/schema_oms_3a.svg">
        <v-text-field
          v-model="form.right_without_elbow_a"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Droite A"
          :class="{ error: errors.has('(Schéma Sans Coude) Droite A') }"
          outlined
          type="number"
          style="top: 0.1%;left: 17.2%;"
          height="100%"
        />
        <v-text-field
          v-model="form.right_without_elbow_b"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Droite B"
          :class="{ error: errors.has('(Schéma Sans Coude) Droite B') }"
          outlined
          type="number"
          style="top: 12.2%;left: 17.2%;"
          height="100%"
        />
        <v-text-field
          v-model="form.right_without_elbow_c"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Droite C"
          :class="{ error: errors.has('(Schéma Sans Coude) Droite C') }"
          outlined
          type="number"
          style="top: 30%;left: 17.2%;"
          height="100%"
        />
        <v-text-field
          v-model="form.right_without_elbow_d"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Droite D"
          :class="{ error: errors.has('(Schéma Sans Coude) Droite D') }"
          outlined
          type="number"
          style="top: 38.7%;left: 17.2%;"
          height="100%"
        />
        <v-text-field
          v-model="form.right_without_elbow_e"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Droite E"
          :class="{ error: errors.has('(Schéma Sans Coude) Droite E') }"
          outlined
          type="number"
          style="top: 49.9%;left: 3.4%;"
          height="100%"
        />

        <v-text-field
          v-model="form.right_without_elbow_f"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Droite F"
          :class="{ error: errors.has('(Schéma Sans Coude) Droite F') }"
          outlined
          type="number"
          style="top: 71.7%;left: 3.4%;"
          height="100%"
        />

        <v-text-field
          v-model="form.right_without_elbow_g"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Droite G"
          :class="{ error: errors.has('(Schéma Sans Coude) Droite G') }"
          outlined
          type="number"
          style="top: 45.9%;left: 12.5%;"
          height="100%"
        />

        <v-text-field
          v-model="form.without_elbow_h"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Droite H"
          :class="{ error: errors.has('(Schéma Sans Coude) Droite H') }"
          outlined
          type="number"
          style="top: 25.8%;left: 45.5%;"
          height="100%"
        />

        <v-text-field
          v-model="form.without_elbow_i"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Droite I"
          :class="{ error: errors.has('(Schéma Sans Coude) Doite I') }"
          outlined
          type="number"
          style="top: 56.7%;left: 45.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_without_elbow_a"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Gauche A"
          :class="{ error: errors.has('(Schéma Sans Coude) Gauche A') }"
          outlined
          type="number"
          style="top: 0.1%;left: 74.4%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_without_elbow_b"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Gauche B"
          :class="{ error: errors.has('(Schéma Sans Coude) Gauche B') }"
          outlined
          type="number"
          style="top: 12.2%;left: 74.1%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_without_elbow_c"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Gauche C"
          :class="{ error: errors.has('(Schéma Sans Coude) Gauche C') }"
          outlined
          type="number"
          style="top: 30%;left: 74.1%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_without_elbow_d"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Gauche D"
          :class="{ error: errors.has('(Schéma Sans Coude) Gauche D') }"
          outlined
          type="number"
          style="top: 38.7%;left: 74.1%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_without_elbow_e"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Gauche E"
          :class="{ error: errors.has('(Schéma Sans Coude) Gauche E') }"
          outlined
          type="number"
          style="top: 49.9%;left: 87.8%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_without_elbow_f"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Gauche F"
          :class="{ error: errors.has('(Schéma Sans Coude) Gauche F') }"
          outlined
          type="number"
          style="top: 71.7%;left: 87.8%;"
          height="100%"
        />

        <v-text-field
          v-model="form.left_without_elbow_g"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Sans Coude) Gauche G"
          :class="{ error: errors.has('(Schéma Sans Coude) Gauche G') }"
          outlined
          type="number"
          style="top: 45.9%;left: 79.3%;"
          height="100%"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpperLimbOrthosisStepThreeA",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  created() {
    this.$validator = this.parentValidator;
  }
};
</script>

<style lang="scss">
.upper-limb-orthosis-step-three-a {
  .content {
    display: flex;
    min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        height: 100%;
        width: 100%;
        min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 8.1%;
        height: 7.3%;
        @media (max-width: 800px) {
          height: 6%;
        }
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
}
</style>
